// Centralized avatar fallback logic for profiles / users

const LGS_DEFAULT = "/images/lgs_default.png"; // Ensure this file exists in /public/images/

type MaybeProfile = {
  avatar_url?: string | null;
  avatarUrl?: string | null;
  avatar?: string | null;
  isLGS?: boolean;
  organizerIsLGS?: boolean;
  roles?: { lgs?: boolean };
  images?: string[];
};

function truthyUrl(u?: string | null) {
  return typeof u === "string" && u.trim().length > 0 ? u : null;
}

export function isLgsLike(p?: MaybeProfile | null): boolean {
  if (!p) return false;
  return Boolean(
    p.isLGS === true ||
    p.organizerIsLGS === true ||
    (p.roles && p.roles.lgs === true)
  );
}

/**
 * Returns a URL to display as the profile avatar.
 * - supplied avatar if present
 * - if LGS-like and no avatar, returns the LGS default image
 * - else null
 */
export function getAvatarUrlForProfile(p?: MaybeProfile | null): string | null {
  if (!p) return null;

  const provided =
    truthyUrl(p.avatar_url) ||
    truthyUrl(p.avatarUrl) ||
    truthyUrl(p.avatar);

  if (provided) return provided;

  if (isLgsLike(p)) return LGS_DEFAULT;

  return null;
}

export function getAvatarUrlFromBits(opts: {
  avatar?: string | null;
  avatarUrl?: string | null;
  avatar_url?: string | null;
  isLGS?: boolean;
  organizerIsLGS?: boolean;
  roles?: { lgs?: boolean };
}): string | null {
  return getAvatarUrlForProfile(opts);
}
